// IRM's user permission value
export enum IRM_PERMISSIONS {
  READ_ACCESS = "Read Only",
  ADD_EDIT_ORDERS = "Update Orders",
  SIGN_CONTRACTS = "Sign Contracts",
  USER_MANAGEMENT = "Admin",
  REQUEST_CONTRACT = "Request Contract",
}

// Permission display value
export enum DISPLAYED_PERMISSIONS {
  READ_ACCESS = "Read Access",
  ADD_EDIT_ORDERS = "Add/Edit Orders",
  SIGN_CONTRACTS = "Sign Contracts",
  USER_MANAGEMENT = "User Management",
  REQUEST_CONTRACT = "Request Contract",
}

export const permissionKeyToPermissionValue: Record<
  keyof UserPermissionsFlags,
  IRM_PERMISSIONS
> = {
  readAccess: IRM_PERMISSIONS.READ_ACCESS,
  addEditOrders: IRM_PERMISSIONS.ADD_EDIT_ORDERS,
  signContracts: IRM_PERMISSIONS.SIGN_CONTRACTS,
  userManagement: IRM_PERMISSIONS.USER_MANAGEMENT,
  requestContract: IRM_PERMISSIONS.REQUEST_CONTRACT,
};

export const permissionsObjectToPermissionValues = (
  permissions: UserPermissionsFlags
): string[] => {
  return Object.entries(permissions).reduce(
    (current, [permissionKey, permissionEnabled]) =>
      permissionEnabled
        ? [
            ...current,
            permissionKeyToPermissionValue[
              permissionKey as keyof typeof permissionKeyToPermissionValue
            ],
          ]
        : current,
    [] as string[]
  );
};
export const permissionValuesToPermissionsObject = (
  permissions: string[]
): UserPermissionsFlags => {
  return {
    readAccess: permissions.includes(IRM_PERMISSIONS.READ_ACCESS) ?? false,
    userManagement:
      permissions.includes(IRM_PERMISSIONS.USER_MANAGEMENT) ?? false,
    signContracts:
      permissions.includes(IRM_PERMISSIONS.SIGN_CONTRACTS) ?? false,
    addEditOrders:
      permissions.includes(IRM_PERMISSIONS.ADD_EDIT_ORDERS) ?? false,
    requestContract:
      permissions.includes(IRM_PERMISSIONS.REQUEST_CONTRACT) ?? false,
  };
};

const irmPermissionToDisplayed: Record<string, DISPLAYED_PERMISSIONS> = {
  [IRM_PERMISSIONS.READ_ACCESS]: DISPLAYED_PERMISSIONS.READ_ACCESS,
  [IRM_PERMISSIONS.USER_MANAGEMENT]: DISPLAYED_PERMISSIONS.USER_MANAGEMENT,
  [IRM_PERMISSIONS.ADD_EDIT_ORDERS]: DISPLAYED_PERMISSIONS.ADD_EDIT_ORDERS,
  [IRM_PERMISSIONS.SIGN_CONTRACTS]: DISPLAYED_PERMISSIONS.SIGN_CONTRACTS,
  [IRM_PERMISSIONS.REQUEST_CONTRACT]: DISPLAYED_PERMISSIONS.REQUEST_CONTRACT,
};

export const permissionValueToDisplayValue = (
  permissionValue: string
): DISPLAYED_PERMISSIONS | string =>
  Object.hasOwn(irmPermissionToDisplayed, permissionValue)
    ? irmPermissionToDisplayed[permissionValue]
    : permissionValue;
